<template> 
    <div> 
      <div class="ms-4">
          <div class="page-title flex-row me-3"> 
              <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('stock_sales_report') }}
              </h1> 
              <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                  <li class="breadcrumb-item text-gray-600">
                      <a href="#" class="text-gray-600 text-hover-primary">
                          <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                      </a>
                  </li> 
                  <li class="breadcrumb-item text-primary">{{ $t('reports') }}</li> 
                  <li class="breadcrumb-item text-primary">{{ $t('stock_reports') }}</li>    
                  <li class="breadcrumb-item text-gray-600">{{ $t('stock_sales_report') }}
                      <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon> 
                  </li> 
              </ul> 
          </div>  
      </div>
      <div class="content flex-row-fluid mt-4" id="kt_content">
          <div class="card">
              <div class="row fv-row border-0 pt-6 px-9">
                  <div class="col-lg-9">
                      <div class="fv-row mb-4 row">  
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('stock_group') }}</span>
                            </label>
                            <Select2 v-model="this.form.stock_group" :options="this.stockGroupList" :settings="{ width: '100%' }"/>
                        </div>  
                        
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('product_group') }}</span>
                            </label>
                            <Select2 v-model="this.form.product_group" :options="this.productGroupList" :settings="{ width: '100%' }" @select="onChangeProductGroup()"/>
                        </div> 
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('product_type') }}</span>
                            </label>
                            <Select2 v-model="this.form.product_type" :options="this.productTypeList" :settings="{ width: '100%' }"/>
                        </div>   
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('report_type') }}</span>
                            </label>
                            <Select2 v-model="form.report_type" :options="reportTypes"  :settings="{ width: '100%' }"/>
                        </div>
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12" v-if="form.report_type == '2'">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('start_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12" v-if="form.report_type == '2'">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('end_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>
                        <div class="col-lg col-md-4 col-sm-6 col-xs-12">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('empty_stocks') }}</span>
                            </label>
                            <Select2 v-model="this.form.with_no_balance" :options="this.viewEmptyList" :settings="{ width: '100%' }"/>
                        </div> 
                      </div>  
                  </div>
                  <div class="col-lg-3">
                      <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(72,'R')"> 
                          <Popper hover placement="top">
                              <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                  <i class="bi bi-eraser-fill fs-4"> </i>
                              </button>
                              <template #content>
                                  <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                              </template>
                          </Popper> 
                          <button type="button" class="btn btn-light-primary border border-primary" @click="getListData()" data-kt-indicator="on">
                              <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                              <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                              <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                              </svg>
                              </span>
                              <span v-if="!this.isListProgressing"> {{ $t('list_transactions') }} </span> 
                              <span class="indicator-progress" v-if="this.isListProgressing">
                                  {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                              </span> 
                          </button> 
                      </div>
                      <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                          <div class="fw-bolder me-5">
                          <span class="me-2" data-kt-customer-table-select="selected_count"></span>{{ $t('selected') }}</div>
                          <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">{{ $t('delete_selected') }}</button>
                      </div>
                  </div>
              </div>
              <div class="card-body pt-3">
                  <div class="separator my-3 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                  <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                      <div class="table-responsive min-h-300px">
                          <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions>
                           <DxDataGrid id="gridContainer"
                                  :key="$i18n.locale"
                                  :show-borders="true"
                                  key-expr="id"
                                  :data-source="lists"
                                  :allow-column-reordering="true" 
                                  :allow-column-resizing="true"
                                  :column-auto-width="true"
                                  :row-alternatin-enabled="true"
                                  :hover-state-enabled="true" 
                                  :show-row-lines="true" 
                                  :ref="'dataGrid'"
                                  @exporting="this.$onExporting($event , 'General-List')">   
  
                                  <DxFilterRow :visible="true"/>
                                  <DxHeaderFilter :visible="true"/>
                                  <DxGroupPanel :visible="true"/>      
                                  <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                  <DxPaging :page-size="pageSize"/>
                                  <DxPager :visible="false" :allowed-page-sizes="pageSizesLists" :show-page-size-selector="showPageSizeSelectorLists" :show-info="true" :show-navigation-buttons="true"/>    
                                  <DxSearchPanel :visible="true"/>
                                  <DxScrolling
                                      mode="virtual"
                                      row-rendering-mode="virtual"
                                  />
                                  <DxColumn data-field="product_code" :caption="$t('product_code')" header-cell-template="product-code-header"/>
                                  <DxColumn data-field="stock_code" :caption="$t('stock_code')" header-cell-template="stock-code-header" />
                                  <DxColumn data-field="name" :caption="$t('stock_name')" header-cell-template="stock-name-header" cell-template="stock-name-cell-template"/>
                                  <DxColumn data-field="turnover_quantity" :sorting-method="this.$numericSort" :caption="$t('turnover_qty')" header-cell-template="turnover-qty-header" alignment="right"/>
                                  <DxColumn data-field="turnover_amount" :sorting-method="this.$numericSort" :caption="$t('turnover_amount')" header-cell-template="turnover-amount-header" alignment="right"/>
                                  <DxColumn data-field="in_quantity" :sorting-method="this.$numericSort" :caption="$t('in_qty')" header-cell-template="in-qty-header" alignment="right"/>
                                  <DxColumn data-field="in_amount" :sorting-method="this.$numericSort" :caption="$t('in_amount')" header-cell-template="in-amount-header" alignment="right"/>
                                  <DxColumn data-field="out_quantity" :sorting-method="this.$numericSort" :caption="$t('out_qty')" header-cell-template="out-qty-header" alignment="right"/>
                                  <DxColumn data-field="out_amount" :sorting-method="this.$numericSort" :caption="$t('out_amount')" header-cell-template="out-amount-header" alignment="right"/>
                                  <DxColumn data-field="current_quantity" :sorting-method="this.$numericSort" :caption="$t('current_qty')" header-cell-template="current-qty-header" alignment="right"/>
                                  <DxColumn data-field="current_amount" :sorting-method="this.$numericSort" :caption="$t('current_amount')" header-cell-template="current-amount-header" alignment="right"/>
                                  <DxColumn data-field="current_quantity2" :sorting-method="this.$numericSort" :caption="$t('quantity_2')"  alignment="right"/>
                                  <DxColumn cssClass="bg-light-indigo" data-field="sale_quantity" :sorting-method="this.$numericSort" :caption="$t('sale_cost_amount')" header-cell-template="sale-qty-header" alignment="right"/>
                                  <DxColumn cssClass="bg-light-indigo" data-field="profit" :sorting-method="this.$numericSort" :caption="$t('profit')" alignment="right"/>
                                  <DxColumn data-field="stock_group_name" :caption="$t('stock_group')" header-cell-template="stock-group-header"/> 
                                  <DxColumn data-field="product_group_name" :caption="$t('product_group')" header-cell-template="product-group-header"/> 
                                  <DxColumn data-field="product_type_name" :caption="$t('product_type')" header-cell-template="product-type-header"/> 
                                  <DxColumn data-field="product_detail_name" :caption="$t('product_detail')" header-cell-template="product-detail-header"/> 
  
                                  <template #stock-code-header>
                                      <div>{{ $t('stock_code') }}</div>
                                  </template>
                                  <template #stock-name-header>
                                      <div>{{ $t('stock_name') }}</div>
                                  </template>
                                  <template #product-code-header>
                                      <div>{{ $t('product_code') }}</div>
                                  </template>
                                  <template #turnover-qty-header>
                                      <div>{{ $t('turnover_quantity') }}</div>
                                  </template>
                                  <template #turnover-amount-header>
                                      <div>{{ $t('turnover_amount') }}</div>
                                  </template>
                                  <template #in-qty-header>
                                      <div>{{ $t('in_quantity') }}</div>
                                  </template>
                                  <template #in-amount-header>
                                      <div>{{ $t('in_amount') }}</div>
                                  </template>
                                  <template #out-qty-header>
                                      <div>{{ $t('out_quantity') }}</div>
                                  </template>
                                  <template #out-amount-header>
                                      <div>{{ $t('out_amount') }}</div>
                                  </template>
                                  <template #sale-qty-header>
                                      <div>{{ $t('sale_quantity') }}</div>
                                  </template>
                                  <template #current-qty-header>
                                      <div>{{ $t('current_quantity') }}</div>
                                  </template>
                                  <template #current-amount-header>
                                      <div>{{ $t('current_amount') }}</div>
                                  </template>
                                  <template #stock-group-header>
                                      <div>{{ $t('stock_group') }}</div>
                                  </template>
                                  <template #product-group-header>
                                      <div>{{ $t('product_group') }}</div>
                                  </template>
                                  <template #product-type-header>
                                      <div>{{ $t('product_type') }}</div>
                                  </template>
                                  <template #product-detail-header>
                                      <div>{{ $t('product_detail') }}</div>
                                  </template>
                                  <template #stock-name-cell-template=" {data}">
                                      <div> {{data.data.name}} <small v-if="data.data.is_bundle_product == 1" class="ms-2 badge badge-sm badge-success">{{ $t('bundle') }}</small></div>
                                  </template>
                                  <DxSummary :calculate-custom-summary="setDetailSummaries">
                                      <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="stock_code"/>
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="in_quantity"
                                        summary-type="custom"
                                        show-in-column="in_quantity"
                                        display-format="{0}"
                                        />  
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="in_amount"
                                        summary-type="custom"
                                        show-in-column="in_amount"
                                        display-format="{0}"
                                        /> 
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="out_quantity"
                                        summary-type="custom"
                                        show-in-column="out_quantity"
                                        display-format="{0}"
                                        /> 
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="out_amount"
                                        summary-type="custom"
                                        show-in-column="out_amount"
                                        display-format="{0}"
                                        /> 
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="sale_quantity"
                                        summary-type="custom"
                                        show-in-column="sale_quantity"
                                            display-format="{0}"
                                        /> 
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="profit"
                                        summary-type="custom"
                                        show-in-column="profit"
                                        display-format="{0}"
                                        /> 
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="current_amount"
                                        summary-type="custom"
                                        show-in-column="current_amount"
                                        display-format="{0}"
                                        /> 
                                        <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="current_quantity2"
                                        summary-type="custom"
                                        show-in-column="current_quantity2"
                                        display-format="{0}"
                                        /> 
                                        <DxTotalItem
                                        name="in_quantity"
                                        summary-type="custom"
                                        show-in-column="in_quantity"
                                        display-format="{0}"
                                        />
                                        <DxTotalItem
                                        name="in_amount"
                                        summary-type="custom"
                                        show-in-column="in_amount"
                                        display-format="{0}"
                                        />
                                        <DxTotalItem
                                        name="out_quantity"
                                        summary-type="custom"
                                        show-in-column="out_quantity"
                                        display-format="{0}"
                                        />
                                        <DxTotalItem
                                        name="out_amount"
                                        summary-type="custom"
                                        show-in-column="out_amount"
                                        display-format="{0}"
                                        />
                                        <DxTotalItem
                                        name="sale_quantity"
                                        summary-type="custom"
                                        shon-in-column="sale_quantity"
                                        display-format="{0}"
                                        />
                                        <DxTotalItem
                                        name="profit"
                                        summary-type="custom"
                                        shon-in-column="profit"
                                        display-format="{0}"
                                        />
                                        <DxTotalItem
                                            name="current_quantity"
                                            summary-type="custom"
                                            show-in-column="current_quantity"
                                            display-format="{0}"
                                        />
                                        <DxTotalItem
                                            name="current_amount"
                                            summary-type="custom"
                                            show-in-column="current_amount"
                                            display-format="{0}"
                                        />
                                        <DxTotalItem
                                            name="current_quantity2"
                                            summary-type="custom"
                                            show-in-column="current_quantity2"
                                            display-format="{0}"
                                        />
                                  </DxSummary>
  
                                  <DxStateStoring
                                      :enabled="true"
                                      type="custom"
                                      :storage-key="this.storageKey"
                                      :ref="dataGrid" 
                                      :saving-timeout="1000"
                                      :custom-load="LoadDXState"
                                  />
                          </DxDataGrid>     
                      </div>  
                  </div> 
                  </div>
          </div> 
      </div>
    </div>  
</template>
  <script>
  import axios from 'axios' 
  
  import moment from 'moment'; 
  import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn,DxGroupItem, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxScrolling } from 'devextreme-vue/data-grid';
   
  export default {
    name: "StockSaleList",
    components:{
      DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn,DxGroupItem, DxSearchPanel, DxStateStoring, DxTotalItem, DxSummary, DxScrolling
    }, 
    data() {
      return {
        storageKey: 'dx_' + this.$options.name,
        pageSize: 100,
        pageSizeDetailList: 10,
        page_size: 20,
        lists: [],
        form:  {
            start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            end_date: moment(),
            stock_group: '-1',
            product_group: '-1',
            product_type: '-1',
            report_type: '1',
            with_no_balance: 1
        },
        isListProgressing: false,
        isFilterOpen: false,
        stockGroupList: [],
        productGroupList: [],
        productTypeList: [],
        reportTypes: [{ id: '1', text: this.$t('general')}, { id: '2', text: this.$t('date_range')}],
        menuSelection: '/StockSalesHelppage',
        iconView : false,
        viewEmptyList: [ { id: 0, text: this.$t('no_view')}, { id: 1, text: this.$t('view_all')}, { id: 2, text: this.$t('view_positive_stocks') },{ id: 3, text: this.$t('view_negative_stocks')},{ id: 4, text: this.$t('view_zero_stocks')}], 
      };
    },
    computed: {
     previewDate(){
        return (value)=>{
         if (value) {
            return moment(new Date(value)).format('DD.MM.YYYY')
          }
        }
      },
      showPageSizeSelectorLists() {
          return this.lists.length > this.pageSize;
      },
      pageSizesLists() {
          let arr = [];
          let x = 1;
          let loop = (this.lists.length / this.pageSize);
          for (let i = 1; i <= loop && i <= 5; i++) {
              arr.push(this.pageSize * x);
              x++;
          }
          if(loop > 5) arr.push(1000);
          if(loop > 1) arr.push('all');
          return arr;
      },
    },
    methods: {
      getData(){ 
              this.$Progress.start();
              const parameters = {
                  session_id: this.$getUser().session_id,
                  list_types: [{ list_type: 6, list_name: "stock_group"}],
                  list_name: ["currency", "account_setting", "product_group"],
                  account_type: 7 // yalnızca account settings listesi çekilecek ise gerekli
              };  
              
              const requestOne =  axios.post('/api/Helper/GetMultiLists', parameters, {'Content-Type': 'application/json'});
              const requestTwo =  axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'}); 
              
              axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
                      this.stockGroupList = responses[0].data.stock_group; 
                      this.productGroupList = responses[1].data.product_group;
                      this.stockGroupList.unshift({ id: '-1', text: this.$t('all')}); 
                      this.productGroupList.unshift({ id: '-1', text: this.$t('all')});
                      this.productTypeList.unshift({ id: '-1', text: this.$t('all')}); 
                      this.productGroupList.forEach((value) => {
                          if(value.is_default) {
                              this.form.product_group_id = value.id;
                          }
                      });
                      this.$Progress.finish();
                  })
                )
                .catch(errors => { 
                  console.error(errors); 
                  this.$Progress.finish();
              });  
      },
      onChangeProductGroup() {
          this.productTypeList = [];
          const params = {
              session_id: this.$getUser().session_id,
              parent_id: this.form.product_group
          };
          axios.post("/api/Helper/GetProductTypeParentList", params, {'Content-Type': 'application/json'}).then((response) => { 
              this.productTypeList = response.data;
              this.productTypeList.unshift({ id: '-1', text: this.$t('all')}); 
              this.form.product_type = this.productTypeList[0].id;
              this.productTypeList.forEach((value) => {
                  if(value.is_default) {
                      this.form.product_type = value.id;
                  }
              });
              this.$Progress.finish();
          })
          .catch((error) => {
              console.error(error);
              this.$Progress.finish();
          });
      },
      setCriteriasToDefault() {   
        this.form = {
            start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            end_date: moment(),
            stock_group: '-1',
            product_group: '-1',
            product_type: '-1',
            report_type: '1',
            with_no_balance: 1
        };
        this.lists = [];
      },
      getListData() {
          this.$Progress.start();
          this.isListProgressing = true;
          this.form.start_date = (this.form.start_date == null || this.form.start_date == '') ? moment() : this.form.start_date;
          this.form.end_date = ( this.form.end_date == null || this.form.end_date == '') ? moment () : this.form.end_date; 
          const params = {
            session_id: this.$getUser().session_id,
            start_date: moment(this.form.start_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            end_date: moment(this.form.end_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            report_type: this.form.report_type,
            stock_group: this.form.stock_group == '-1'? null : this.form.stock_group,
            product_group: this.form.product_group == '-1'? null : this.form.product_group,
            product_type: this.form.product_type == '-1'? null : this.form.product_type,
            with_no_balance: this.form.with_no_balance == 0 ? 0 : this.form.with_no_balance,
          };
          axios.post('/api/StockReports/GetGeneralStockList', params, {'Content-Type': 'application/json'})
          .then((response) => {
              this.lists = !response.data.error ? response.data.report_data : [];
              this.page = 1;
              this.$Progress.finish();
              setTimeout(() => {
                  this.isListProgressing = false;
              }, 500);
          })
          .catch((error) => {
              console.error(error);
              this.$Progress.finish();
              setTimeout(() => {
                  this.isListProgressing = false;
              }, 500);
          });  
      },
      /** DX STATE OPERATIONS **/  
      LoadDXState() {
          return JSON.parse(sessionStorage.getItem(this.storageKey));
      }, 
      async helpPageViewIcon()
      {
          const queryparameter = {
              session_id : this.$getUser().session_id,
              menu_selection : '/GeneralStockReportHelppage'
          };
          axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
          .then((response) => { 
              if(!response.data.error){ 
                  this.iconView = response.data;
              }
          })
      }, 
      setDetailSummaries(options){  
          const optionNames = ["in_quantity", "in_amount", "out_quantity", "out_amount", "sale_quantity", "profit", "current_quantity", "current_amount", "current_quantity2"]; 
          optionNames.forEach(item => {
              if(options.name == item){
                  if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                  else if(options.summaryProcess === 'calculate'){
                      var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                      (options.totalValue += itemValue);
                  }
                  else if(options.summaryProcess === 'finalize'){ 
                      options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                  }
              }
          });
      },
    },
    created() {
      this.helpPageViewIcon();
      this.$removeSessionStorage('record_id');
      this.lists = [];
      this.getData();
    }
  }; 
  </script>